module.exports = __webpack_public_path__ + "static/media/less_disabled.5ab97704.svg";